module.exports = __webpack_public_path__ + "static/media/pp_clear_bendable_straw1.2376cf24.png";